import { useAppSelector } from 'hooks/useStore'
import { ReactElement, useEffect, useMemo, useState } from 'react'
import { Theme } from 'theme/theme'
import { componentByMonth } from './dashboardFigures.helpers'
import DownloadButton from 'components/DownloadButton'
import { ApiArtizenBO } from 'utils/artizenConnector'
import { InterventionClass, InterventionStatus } from '@Arti-zen/package-backoffice'
import { fetchAllPages } from 'utils/async'
import { Button } from '@mui/material'
import { Format } from 'utils/format'

export default function DashboardInterventionsFigures(): ReactElement {
  const { dateStart, dateEnd } = useAppSelector((state) => state.dashboard)
  const [interventions, setInterventions] = useState<InterventionClass['meilisearchDoc'][]>([])
  const [isLoading, setIsLoading] = useState(false)
  const [needRefresh, setNeedRefresh] = useState(true)

  useEffect(() => {
    setNeedRefresh(true)
  }, [dateStart, dateEnd])

  const refresh = () => {
    setIsLoading(true)
    setNeedRefresh(false)

    fetchAllPages(ApiArtizenBO.interventions.get, {
      after: dateStart.toJSDate(),
      before: dateEnd.toJSDate()
    })
      .then(setInterventions)
      .finally(() => setIsLoading(false))
  }

  type InterventionStats = Record<number, Record<number, InterventionClass['meilisearchDoc'][]>>

  const interventionStats = useMemo<InterventionStats>(() => {
    return interventions.reduce((acc, intervention) => {
      if (intervention.hidden || intervention.isPrivate) return acc
      const d = new Date(intervention.interventionStartDate)

      const year = d.getFullYear()
      const month = d.getMonth() + 1 // 1-12

      if (!acc[year]) {
        acc[year] = {}
      }

      if (!acc[year][month]) {
        acc[year][month] = []
      }

      acc[year][month].push(intervention)

      return acc
    }, {} as InterventionStats)
  }, [interventions])

  if (needRefresh) {
    return (
      <>
        <Button variant="contained" onClick={refresh}>
          Actualiser
        </Button>
      </>
    )
  }

  return isLoading ? (
    <>Chargement en cours...</>
  ) : (
    <>
      <tr>
        <td
          style={{
            fontWeight: 600,
            color: Theme.colors.blueArtizen,
            display: 'flex',
            flexDirection: 'row',
            gap: 10,
            alignItems: 'center',
          }}
        >
          Interventions
          {!!interventions && (
            <DownloadButton data={interventions} fileName="interventions" label={null} size="small" />
          )}
        </td>
      </tr>

      {!interventionStats ? null : (
        <>
          <tr>
            <td style={{ textAlign: 'right' }}>Nombre</td>
            {componentByMonth({
              dateStart,
              dateEnd,
              component: (year, month) => (
                <td style={{ padding: 10, textAlign: 'center' }}>
                  <div>{Format.number(interventionStats[year]?.[month]?.length || 0)}</div>
                </td>
              ),
            })}
          </tr>
          {/* <tr>
            <td style={{ textAlign: 'right' }}>User unique</td>
            {componentByMonth({
              dateStart,
              dateEnd,
              component: (year, month) => (
                <td style={{ padding: 10, textAlign: 'center' }}>
                  
                  <div>{
                  //@ts-ignore
                  interventionStats[year]?.[month]?.uniqueUserCount}</div>
                </td>
              ),
            })}
          </tr> */}
        </>
      )}
    </>
  )
}
